const TriviaThemeColors = {
	vibrantPeriwinkle: '#4f24ff',
	vibrantPeriwinkleButtonBg1:  '#4f24ff',
	vibrantPeriwinkleButtonBg2:  '#6e24ff',
	vibrantPeriwinkleButtonText: '#e4e0f3',

	midnightContainerBg: '#140836',
}

export default TriviaThemeColors 